"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOP = exports.SELF = exports.PARENT = exports.BLANK = void 0;
/** @deprecated use string constant adhering to exported type ActionTarget instead */
exports.BLANK = '_blank';
/** @deprecated use string constant adhering to exported type ActionTarget instead */
exports.PARENT = '_parent';
/** @deprecated use string constant adhering to exported type ActionTarget instead */
exports.SELF = '_self';
/** @deprecated use string constant adhering to exported type ActionTarget instead */
exports.TOP = '_top';
